import React, { useState } from 'react';
import axios from 'axios';
import baseURL, { getAuthHeaders, handleAuthError } from './baseUrl';

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    if (newPassword.length < 4) {
      setError('New password must be at least 4 characters');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.put(`${baseURL}/api/auth/change-password`,
        { currentPassword, newPassword },
        { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
      );
      setSuccess(res.data.message);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: '500px' }}>
      <h3 style={{ color: '#FFD700' }} className="mb-4">Change Password</h3>

      {error && <div className="alert alert-danger py-2">{error}</div>}
      {success && <div className="alert alert-success py-2">{success}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label text-light">Current Password</label>
          <input
            type="password"
            className="form-control"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            style={{ backgroundColor: '#3d3d3d', border: '1px solid #555', color: 'white' }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label text-light">New Password</label>
          <input
            type="password"
            className="form-control"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={4}
            style={{ backgroundColor: '#3d3d3d', border: '1px solid #555', color: 'white' }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label text-light">Confirm New Password</label>
          <input
            type="password"
            className="form-control"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={4}
            style={{ backgroundColor: '#3d3d3d', border: '1px solid #555', color: 'white' }}
          />
        </div>
        <button type="submit" className="btn btn-warning w-100" disabled={loading}>
          {loading ? 'Changing...' : 'Change Password'}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
